import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

type ListProps = {
    isDirectLink: boolean
}

export const List = styled("ul")<ListProps>`
    display: flex;
    flex-direction: row;
    margin: 0;
    padding: 0 1rem;
    padding-right: ${props => (props.isDirectLink ? 0 : "initial")};
    align-items: start;
    height: inherit;
    flex-wrap: wrap;
    width: 100%;
    @media (min-width: ${breakpoints.values.md}px) {
        padding-left: 2rem;
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        padding: 0;
        flex-direction: column;
        flex-wrap: nowrap;
    }
    @media (max-width: ${breakpoints.values.lg - 1}px) {
        height: ${({isDirectLink}) => (isDirectLink ? "auto" : "inherit")};
        align-items: center;
    }
`
